import { render, staticRenderFns } from "./BrokerRealEstateDevelopmentView.vue?vue&type=template&id=6fd643c8"
import script from "./BrokerRealEstateDevelopmentView.vue?vue&type=script&lang=js"
export * from "./BrokerRealEstateDevelopmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports